import axios from "axios";
import { ApiKey, liveURL } from "../constants/Consts";

const API_URL = `${liveURL}/about`;

export async function getAboutSections(params = {}) {
  try {
    const response = await axios.get(API_URL, {
      params,
      headers: { apikey: ApiKey },
    });
    return response.data;
  } catch (error) {
    return { success: false, message: error.message };
  }
}

export async function createAboutSection(data) {
  try {
    const response = await axios.post(API_URL, data, {
      headers: { apikey: ApiKey },
    });
    return response.data;
  } catch (error) {
    return { success: false, message: error.message };
  }
}

export async function updateAboutSection(id, data) {
  try {
    const response = await axios.put(`${API_URL}/${id}`, data, {
      headers: { apikey: ApiKey },
    });
    return response.data;
  } catch (error) {
    return { success: false, message: error.message };
  }
}

export async function deleteAboutSection(id) {
  try {
    const response = await axios.delete(`${API_URL}/${id}`, {
      headers: { apikey: ApiKey },
    });
    return response.data;
  } catch (error) {
    return { success: false, message: error.message };
  }
} 